import { IframeWidget as IframeWidgetType } from 'types/dashboard_widget';

import { Widget } from 'dashboards/widgets/Widget/Widget';

export function IframeWidget(widget: IframeWidgetType) {
  return (
    <Widget widget={widget}>
      <iframe
        className="h-full w-full border-0"
        src={widget.url}
        sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox allow-forms"
        referrerPolicy="no-referrer"
      />
    </Widget>
  );
}
